import { useState } from 'react';
import { InspectorControls } from '@wordpress/block-editor';
import { TabPanel } from '@wordpress/components';

// Settings Components

import { tabController } from '../../../Components/utils/functions';
import { generalStyleTabs } from '../utils/options';
import Button from './Style/Button';
import SettingsPanel from './General/SettingsPanel';
import GridLayoutPanel from './General/GridLayoutPanel';
import SwipeLayoutPanel from './General/SwipeLayoutPanel';
import QueryPanel from './General/QueryPanel';

const Settings = (props) => {
	const { attributes, setAttributes, allCategories } = props;
	const [device, setDevice] = useState('desktop');

	return <>
		<InspectorControls>
			<TabPanel className='bPlTabPanel bpwpsbTabPanel' activeClass='activeTab' tabs={generalStyleTabs} onSelect={tabController}>{tab => <>
				{'general' === tab.name && <>
					<SettingsPanel device={device} setDevice={setDevice} attributes={attributes} setAttributes={setAttributes} />
					<QueryPanel attributes={attributes} setAttributes={setAttributes} allCategories={allCategories} />
					<GridLayoutPanel device={device} setDevice={setDevice} attributes={attributes} setAttributes={setAttributes} />
					<SwipeLayoutPanel attributes={attributes} setAttributes={setAttributes} />
				</>}

				{'style' === tab.name && <>
					<Button attributes={attributes} setAttributes={setAttributes} device={device} setDevice={setDevice} />
				</>}
			</>}</TabPanel>
		</InspectorControls>
	</>;
};
export default Settings;